// extracted by mini-css-extract-plugin
export default {"page":"xZ-z","cartModal":"yZ-z","checkout":"zZ-z","placeholder":"AZ-z","account":"BZ-z"};